module.exports = __webpack_public_path__ + "static/media/MC3.f2797477.jpeg";